// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSubscriptionbutton_root__3oR2i","text":"PlasmicSubscriptionbutton_text__gMIQL"};